export const isInIframe: () => boolean = (): boolean => {
    try {
        return window.self !== window.top;
    } catch {
        return true;
    }
}
